import Logo from "../images/hemsida Logo H.png";
import Cover from "../images/Cover.png";

function Header() {
  return (
    <>
      <main>
        <div className="cover"></div>
      </main>
    </>
  );
}

export default Header;
